export default "__VITE_PUBLIC_ASSET__0ad8fcfc__"